import axios from 'axios';
import config from '../common/config';

export default {
  getInvite( token, rideId ) {
    return axios.get(`${config.config.ROOT_URL}/api/rides/${rideId}/whatsapp_invite`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  generateInvite( token, rideId ) {
    return axios.post(`${config.config.ROOT_URL}/api/rides/${rideId}/whatsapp_invite`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  },
  getReminderSettings( token, rideId ) {
    return axios.get(`${config.config.ROOT_URL}/api/rides/${rideId}/whatsapp_reminder_settings`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  saveReminderSettings( token, rideId, settings ) {
    return axios.put(`${config.config.ROOT_URL}/api/rides/${rideId}/whatsapp_reminder_settings`, settings, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  },
  exchangeToken( accessToken ) {
    return axios.post(`${config.config.ROOT_URL}/api/whatsapp/session`, { token: accessToken }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
};
